import { useTranslation } from 'i18n';
import { Alert } from 'ui';

import { useNetworkStatus } from '../../hooks/useNetworkStatus/useNetworkStatus';
export const NetworkStatusAlert = () => {
  const { t } = useTranslation('features');
  const { isOnline } = useNetworkStatus();

  return !isOnline ? (
    <Alert severity="warning" sx={{ marginBottom: 2 }}>
      {t('networkStatus.alert.offlineMessage')}
    </Alert>
  ) : null;
};
